import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/css/style.css";
import "./assets/css/font.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import vueFbCustomerChat from "./plugins/vue-fb-customer-chat";
import "animate.css";
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;
Vue.use(require("vue-moment"));

new Vue({
  router,
  store,
  vuetify,
  vueFbCustomerChat,
  render: (h) => h(App),
}).$mount("#app");
